<template>
  <ExternalList
      endpoint="/api/v2/time-based-subchannels"
      :endpoint-filters="{time_based_channel_id: timeBasedChannel.id}"
      :headlines=" [{width: 20, text: 'Name'}]"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      :has-inactive="true"
      :get-row-class="timeBasedSubchannel => !timeBasedSubchannel.attributes.is_active ? 'warning' : ''"
      @show="timeBasedSubchannel => $router.push(getUrl(timeBasedSubchannel))"
  >
    <template v-slot:default="{ row: timeBasedSubchannel }">
      <td>
        <router-link :to="getUrl(timeBasedSubchannel)">
          {{ timeBasedSubchannel.attributes.name }}
        </router-link>
      </td>
    </template>

    <template v-slot:modals="{ load, update }">
      <CreateModal :timeBasedChannel="timeBasedChannel" @created="load"/>
    </template>
  </ExternalList>
</template>

<script>
import CreateModal from '../Modals/Create'
import ExternalList from '../../../Panels/Lists/External'

export default {
  components: {CreateModal, ExternalList},

  props: {
    portal: {
      required: true
    },

    timeBasedChannel: {
      required: true
    }
  },

  methods: {
    getUrl(timeBasedSubchannel) {
      return '/portals/' + this.portal.id + '/time-based-channels/' + this.timeBasedChannel.id + '/time-based-subchannels/' + timeBasedSubchannel.id
    }
  }
}
</script>
